import { render, staticRenderFns } from "./ProfileDataForm.vue?vue&type=template&id=6ebc0536&"
import script from "./ProfileDataForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports